import { createFileRoute } from '@tanstack/react-router'
import { requirePermission } from '../../app/guards'
import { stockValuationSearchSchema } from '../../features/reports/operational-search'
import { StockValuationPage } from '../../features/reports/stock-valuation-page'

export const Route = createFileRoute('/_app/stock-valuation')({
  staticData: { crumb: 'stockValuation' },
  validateSearch: stockValuationSearchSchema,
  beforeLoad: ({ context }) => requirePermission(context.session, 'inventory.read'),
  component: StockValuationPage,
})
